import Cookies from 'js-cookie';
const user_name = Cookies.get('ASG_DisplayName');
const dclog = (dclogUrl,serviceUrl) => {
 // 不处理dclog
}
export default dclog;

